import React from "react";
import { useTranslation } from "react-i18next";

import CardColumn from "components/CardColumn";

const RolesHeadings = () => {
	const { t } = useTranslation();

	return (
		<div className="list-group-heading activity-instances__heading activity-instances__heading--roles">
			<CardColumn width="xl">{t("main.profile.yourRoles")}</CardColumn>
			<CardColumn width="fill">
				{t("main.profile.description")}
			</CardColumn>
		</div>
	);
};

export default RolesHeadings;
